
import React, { Component } from 'react';

var DigiSeal= () => {
	return (
		<span>digiSeal<span className="supsmaller">&reg;</span></span>
	);
}

export default DigiSeal;